import styled from "styled-components";
import { device } from "../breakpoints";

export const HeroBnrContainer = styled.section`
  display: flex;
  height: 100vh;
  background-size: cover;
  position: relative;
  @media ${device.mobile} {
    flex-direction: column;
    height: 70vh;
  }
`;
export const HeroBnrContainerInner = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  @media ${device.mobile} {
    align-items: flex-start;
    flex-direction: column;
  }
`;
export const HeroBnrContent = styled.div`
  width: 1200px;
  display: flex;
  margin: 0 auto;
  @media ${device.mobile} {
    width: 100%;
    padding: 70px 16px 16px 16px;
    flex-direction: column;
  }
`;
export const HeroBnrDtl = styled.div`
  width: 566px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h1 {
    font-size: 56px;
    line-height: 65px;
    color: #000;
    font-weight: 400;
    font-family: "Raleway";
    @media ${device.mobile} {
      font-size: 32px;
      line-height: 38px;
      margin-bottom: 20px;
    }
  }
  @media ${device.mobile} {
    width: 100%;
  }
`;
export const HeroBnrVideo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  @media ${device.mobile} {
    position: relative;
    z-index: 3;
  }
`;
